import { saveFile } from "@/api/Maintainers/users";
import { useMutation } from "react-query";

// DOCS
export function useSaveDocument() {
	return useMutation(saveFile);
}
